// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [valBarangDivisi, setValBarangDivisi] = useState<any>(null)
    const [listBarangDivisi, setListBarangDivisi] = useState<any[]>([])

    const [valBarangKelompok, setValBarangKelompok] = useState<any>(null)
    const [listBarangKelompok, setListBarangKelompok] = useState<any[]>([])

    const [valJenisBarang, setValJenisBarang] = useState<any>(null)
    const [listJenisBarang, setListJenisBarang] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])

    const [valSatuan, setValSatuan] = useState<any>(null)
    const [listSatuan, setListSatuan] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/kelas-barang/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    setValue('mmbarang_divisi_id', data.mmbarang_divisi_id)
                    setValue('mmbarang_kelompok_id', data.mmbarang_kelompok_id)
                    setValue('mmjenis_barang_id', data.mmjenis_barang_id)
                    setValue('mmgudang_id', data.mmgudang_id)
                    setValue('kode', data.kode)
                    setValue('nama', data.nama)
                    setValue('mmsatuan_id', data.mmsatuan_id)
                    setValue('is_asset', data.is_asset)
                    setValue('is_batch', data.is_batch)
                    setValue('is_jasa', data.is_jasa)
                    setValue('is_kain', data.is_kain)
                    setValue('is_stok', data.is_stok)


                    getBarangDivisi(data.mmbarang_divisi_id)
                    getJenisBarang(data.mmjenis_barang_id)
                    getBarangKelompok(data.mmbarang_kelompok_id)
                    getSatuan(data.mmsatuan_id)
                    getGudang(data.mmgudang_id)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getBarangDivisi = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/divisi-barang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValBarangDivisi(element)
                        }
                    });
                    setListBarangDivisi(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getBarangKelompok = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/kelompok-barang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValBarangKelompok(element)
                        }
                    });
                    setListBarangKelompok(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getJenisBarang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/jenis-barang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValJenisBarang(element)
                        }
                    });
                    setListJenisBarang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSatuan = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/satuan/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValSatuan(element)
                        }
                    });
                    setListSatuan(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getGudang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id == ids) {
                            setValGudang(element)
                        }
                    });
                    setListGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleChangeAutocompleteBarangDivisi = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_divisi_id', newValue?.id)
        setValBarangDivisi(newValue)
    }

    const handleChangeAutocompleteBarangKelompok = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_kelompok_id', newValue?.id)
        setValBarangKelompok(newValue)
    }

    const handleChangeAutocompleteJenisBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmjenis_barang_id', newValue?.id)
        setValJenisBarang(newValue)
    }

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue?.id)
        setValGudang(newValue)
    }

    const handleChangeAutocompleteSatuan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmsatuan_id', newValue?.id)
        setValSatuan(newValue)
    }

    interface FormInputs {
        syscabang_id: any,
        mmbarang_divisi_id: any,
        mmbarang_kelompok_id: any,
        mmjenis_barang_id: any,
        mmgudang_id: any,
        kode: any,
        nama: any,
        mmsatuan_id: any,
        is_kain: any,
        is_stok: any,
        is_batch: any,
        is_jasa: any,
        is_asset: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/mm/kelas-barang/edit/' + id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/mm/kelas-barang')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Master Kelas Barang
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Divisi Barang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_divisi_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarangDivisi}
                                                options={listBarangDivisi}
                                                id='mmbarang_divisi_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteBarangDivisi}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Divisi Barang'
                                                        error={Boolean(errors.mmbarang_divisi_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_divisi_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kelompok Barang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmbarang_kelompok_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valBarangKelompok}
                                                options={listBarangKelompok}
                                                id='mmbarang_kelompok_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteBarangKelompok}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Kelompok Barang'
                                                        error={Boolean(errors.mmbarang_kelompok_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmbarang_kelompok_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Jenis Barang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmjenis_barang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJenisBarang}
                                                options={listJenisBarang}
                                                id='mmjenis_barang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteJenisBarang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Jenis Barang'
                                                        error={Boolean(errors.mmjenis_barang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmjenis_barang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Gudang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmgudang_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valGudang}
                                                options={listGudang}
                                                id='mmgudang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteGudang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Gudang'
                                                        error={Boolean(errors.mmgudang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kode
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kode'
                                                error={Boolean(errors.kode)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama'
                                                error={Boolean(errors.nama)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Satuan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmsatuan_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSatuan}
                                                options={listSatuan}
                                                id='mmsatuan_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteSatuan}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Satuan'
                                                        error={Boolean(errors.mmsatuan_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmsatuan_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            &nbsp;
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_kain'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_kain ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Kain ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_kain && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            &nbsp;
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_stok'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_kain ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Stock ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_stok && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            &nbsp;
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_batch'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_kain ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Batch ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_batch && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            &nbsp;
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_jasa'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_kain ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Jasa ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_jasa && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            &nbsp;
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_asset'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_kain ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='Asset ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_asset && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
